import { getToken, isSupported, onMessage } from "firebase/messaging";
import { messaging } from "../config/firebase";

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;
let serviceWorkerRegistrationPromise;

const DEFAULT_NOTIFICATION_TITLE = "Notifikasi baru";

export const parseFirebaseMessagePayload = (payload = {}) => {
  const notificationPayload = payload.notification || {};
  const dataPayload = payload.data || {};

  const title =
    notificationPayload.title ||
    dataPayload.title ||
    dataPayload.notification_title ||
    dataPayload.notificationTitle ||
    dataPayload.subject ||
    DEFAULT_NOTIFICATION_TITLE;

  const body =
    notificationPayload.body ||
    dataPayload.body ||
    dataPayload.notification_body ||
    dataPayload.notificationBody ||
    dataPayload.message ||
    dataPayload.content ||
    "";

  const link =
    notificationPayload.click_action ||
    dataPayload.link ||
    dataPayload.url ||
    dataPayload.click_action ||
    dataPayload.clickAction ||
    "";

  return {
    title,
    body,
    link,
    data: dataPayload,
  };
};

export const registerMessagingServiceWorker = async () => {
  if (!("serviceWorker" in navigator)) {
    throw new Error("Browser tidak mendukung service worker");
  }

  if (!serviceWorkerRegistrationPromise) {
    serviceWorkerRegistrationPromise = navigator.serviceWorker.register(
      `${process.env.PUBLIC_URL}/firebase-messaging-sw.js`
    );
  }

  return serviceWorkerRegistrationPromise;
};

export const initializeFCM = async () => {
  try {
    if (
      typeof window === "undefined" ||
      typeof Notification === "undefined" ||
      Notification.permission !== "granted"
    ) {
      return null;
    }

    const messagingSupported = await isSupported();
    if (!messagingSupported) {
      return null;
    }

    const serviceWorkerRegistration = await registerMessagingServiceWorker();

    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration,
    });

    return token;
  } catch (error) {
    console.error("FCM error:", error);
    return null;
  }
};

export const listenForMessages = (callback) => {
  let unsubscribe = () => {};

  isSupported()
    .then((messagingSupported) => {
      if (messagingSupported) {
        unsubscribe = onMessage(messaging, callback);
      }
    })
    .catch((error) => {
      console.error("FCM listener error:", error);
    });

  return () => unsubscribe();
};
